module.exports = __webpack_public_path__ + "img/stock6.de974cd0.png";